import React, { useContext, useState, useEffect } from "react";
import Buttons from "./Buttons";
import {withRouter} from 'react-router-dom'
import MainContext from '../../state/main/mainContext'
import ReactGA from 'react-ga';

const Modal3 = ({  history: {push} }) => {
  const [errorMsg, setErrorMsg] = useState();
  const [seeError, setSeeError] = useState(false);
  const mainContext = useContext(MainContext)
  const {onChange, formData: { school }} = mainContext;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); 
  }, [])

  const moveForward = () => {
    if (school === "" || school === null) {
      setErrorMsg("Please enter last school attened");
      setSeeError(true);
      console.log("wrong");
      return;
    }
    push('/survey/3')
  };

  const preventSubmit = (e) => {
    e.key === "Enter" && e.preventDefault();
  };

  return (
    <section id="modal-3">
      <div className="container">
        <h6 style={{ visibility: "hidden" }}>
          Which school do you currently attend?
        </h6>
        <div className="top">
          <h2>Which school do you currently attend?</h2>
          <p>(If not enrolled, please list the last school you attended.)</p>
        </div>
        <div className="form">
          <input
            type="text"
            name="school"
            value={school}
            onChange={onChange}
            placeholder="Desert Sands"
            onKeyPress={preventSubmit}
          />
          {seeError && <p className="errorMsg">{errorMsg}</p>}
        </div>
        <Buttons advance={moveForward} goBack={() => {push('/survey/1')}}  />
      </div>
    </section>
  );
};

export default withRouter(Modal3);
